import { render, staticRenderFns } from "./BackgroundSearchHeader.vue?vue&type=template&id=050ef4dc&"
import script from "./BackgroundSearchHeader.vue?vue&type=script&lang=js&"
export * from "./BackgroundSearchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports